import axios from "../../../axios";

export const getUsers = async (org_id) => {
    try {
      let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/organization/${org_id}/users`);      
      return data;
    }catch (err) {
      console.log("Error while getting groups of an organization", err.message);
    }
};
 